import { withProcedureWraper } from "../../../../..";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForTerminationContractForm } from "../../../components/create-application-for-termination-contract-form";

export const TerminationContractCreate = withProcedureWraper(() => {
  return (
    <ProcedureLayout title="Đơn xin chấm dứt hợp đồng lao động">
      <CreateApplicationForTerminationContractForm />
    </ProcedureLayout>
  );
});
